/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import Step1 from '../step1/index.jsx';
import Step2 from '../step2/index.jsx';
import Step3 from '../step3/index.jsx';
import styles from './assets/index.module.css';
import { queryIndexInfo, queryProductDetail, query_product_recommend_list } from '../../services/api.js';
import { useLocation } from 'react-router-dom';

import btn1 from './assets/img/btn-1.png';
import luodiye_pc from './assets/img/luodiye_pc.jpg';
const routeList = [
  { name: '首页', key: 'home' },
  { name: '关于我们', key: 'about' },
  { name: '联系方式', key: 'contact' }
];
const DF = ({ match }) => {
  const { userId } = match.params;
  const [visiable, setVisiable] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [userData, setUserData] = useState({});
  const [route, setRoute] = useState('home');
  const [rawData, setRawData] = useState({});
  const [productDetailData, setProductDetailData] = useState({});
  const [payResult, setPayResult] = useState({});
  const [showDownload, setShowDownload] = useState(true);
  const [recommend, setRecommend] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const res = await query_product_recommend_list(window.location.pathname.slice(1));
      setRecommend(res.data.records || []);
    }
    fetchData();
  }, []);

  const locations = useLocation();
  const handleDownload = () => {
    window.scrollTo(0, 0);

    setVisiable(true);
    // document.querySelector('html').style.paddingRight = '14px';

    document.querySelector('html').style.overflowY = `hidden `;
  };
  const handleCloseDownload = () => {
    setVisiable(false);
    document.querySelector('html').style.paddingRight = '0px';

    document.querySelector('html').style.overflowY = `hidden`;
  };

  const getData = async () => {
    let res = await queryIndexInfo('df');
    if (res.code === 0) {
      setRawData(res.data);
    } else {
      setShowDownload(false);
    }
    let resProductDetailData = await queryProductDetail('df');
    if (resProductDetailData.code === 0) {
      setProductDetailData(resProductDetailData.data);
      document.title = res.data?.siteInfo?.title;
      changeFavicon(res.data?.siteInfo?.iconUrl);
    } else {
      setShowDownload(false);
    }
    // handleDownload();
  };
  function changeFavicon(src) {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = src;
  }

  useEffect(() => {
    getData();
    if (locations.pathname === '/df') {
      document.querySelector('html').style.background = 'rgb(0, 0, 0)';
      document.querySelector('html').style.overflow = 'hidden';
    }
  }, []);

  const skipNewHome = () => {
    window.open(`/home?code=${window.location.pathname.slice(1)}`, '_blank');
  };

  const skipCustomer = () => {
    window.open(`https://work.weixin.qq.com/ca/cawcde88df970f8868`, '_blank');
  };
  return (
    <div className={`${styles.page} flex-col`}>
      {locations.pathname === '/df' && (
        <div className={`${styles['esports-img']}`}>
          <span className={`${styles['btn-box-position']}`}>
            <img className={`${styles['game-bg']}`} src={luodiye_pc} alt='' />
            <img className={`${styles['btn-1']}`} src={btn1} alt='' onClick={() => handleDownload()} />
          </span>
          <div className={`${styles['btn-service']}`} onClick={skipCustomer}>
            在线客服
          </div>
        </div>
      )}
      {locations.pathname !== '/df' && (
        <div className={`${styles['section_1']} flex-col`}>
          <div className={`${styles['box_1']} flex-col`}>
            <div className={`${styles['box_2']} flex-col`}>
              <div className={`${styles['section_2']} flex-row justify-between`}>
                <div className={`${styles['image-wrapper_1']} flex-col`} onClick={skipNewHome}>
                  <img className={`${styles['thumbnail_1']}`} src={require('./assets/img/logo.png')} />
                </div>
              </div>
              <div className={`${styles['section_3']} flex-row`}>
                <div className={`${styles['section_4']} flex-col`}>
                  {/* <div className={`${styles["group_1"]} flex-col`} /> */}
                  <img className={`${styles['img_size_w100']}`} src={rawData?.productInfo?.picUrl} alt='' />
                </div>
              </div>

              <div className={`${styles['section_5']} flex-col`}>
                <div className={`${styles['text-wrapper_1']} flex-row`}>
                  {routeList.map((item, index) => (
                    <span
                      key={index}
                      onClick={() => {
                        if (item.key !== 'home') {
                          window.open(`/aboutus/${userId}`, '_self');
                        } else {
                          setRoute(item.key);
                        }
                      }}
                      className={` ${item.key === route ? styles['text_2'] : styles['text_3']}`}
                    >
                      {item.name}
                    </span>
                  ))}
                </div>
                <img className={`${styles['image_1']}`} src={require('./assets/img/SketchPng5c66b728b2d58f808a24795718001f3c2330120015c02fc18e7c8c98aec3cbf6.png')} />
                {/* <div className={`${styles["block_1"]} flex-col`} /> */}
                <div className={`${styles['block_2']} flex-row justify-between`}>
                  <div className={`${styles['section_6']} flex-col`}>
                    <img className={`${styles['img_size_w66']}`} src={rawData?.productInfo?.iconUrl} alt='' />
                    <div className={`${styles['group_2']} flex-col`} />
                  </div>
                  <span className={`${styles['text_5']}`}>{rawData?.productInfo?.name}</span>
                </div>
                <div className={`${styles['block_3']} flex-row justify-between`}>
                  <div className={`${styles['text-wrapper_2']}`}>
                    <span className={`${styles['text_6']}`}>软件版本：</span>
                    <span className={`${styles['text_7']}`}>{rawData?.productInfo?.version}</span>
                  </div>
                  <div className={`${styles['text-wrapper_3']}`}>
                    <span className={`${styles['text_8']}`}>软件大小：</span>
                    <span className={`${styles['text_9']}`}>{rawData?.productInfo?.size}</span>
                  </div>
                </div>
                <div className={`${styles['block_4']} flex-row justify-between`}>
                  <div className={`${styles['text-wrapper_4']}`}>
                    <span className={`${styles['text_10']}`}>更新时间：</span>
                    <span className={`${styles['text_11']}`}>{rawData?.productInfo?.updateTime}</span>
                  </div>
                  <div className={`${styles['text-wrapper_5']}`}>
                    <span className={`${styles['text_12']}`}>应用平台：</span>
                    <span className={`${styles['text_13']}`}>{rawData?.productInfo?.platform}</span>
                  </div>
                </div>
                {showDownload && (
                  <div className={`${styles['block_5']} flex-row`} onClick={() => handleDownload()}>
                    <img className={`${styles['label_1']}`} src={require('./assets/img/SketchPng664eac5afd38e1468b99e48d649320698c714d13dc0ddd09c349985c19ca454c.png')} />
                    <span className={`${styles['text_14']}`}>立即下载</span>
                  </div>
                )}
                <span className={`${styles['text_15']}`}>通过巨极软件平台，享高速下载等更多增值权益</span>
                <img className={`${styles['image_2']}`} src={require('./assets/img/SketchPng251fc0195a2bcfe8081f6109ab32d3f7d7a1ee590f4d93de8175c9fcdf920429.png')} />
              </div>
            </div>
          </div>
        </div>
      )}
      {locations.pathname !== '/df' && (
        <div className={`${styles['section_7']} flex-col`}>
          {showDownload && (
            <div className={`${styles['group_19']} flex-row justify-between`}>
              <span className={`${styles['text_30']}`}>以上都不需要，使用普通方式下载</span>
              <div className={`${styles['text-wrapper_6']} flex-col`} onClick={() => handleDownload()}>
                <span className={`${styles['text_31']}`}>立即下载</span>
              </div>
            </div>
          )}
          <div className={`${styles['group_20']} flex-col`}>
            <div className={`${styles['paragraph_1_t']}`}>
              <span className={`${styles['padding-l-5']}`}>Copyright©2023</span>
              <span className={`${styles['padding-l-5']}`}>jujjxiazai.com</span>
              <span className={`${styles['padding-l-5']}`}>All rights reserved.</span>
            </div>
            <div className={`${styles['paragraph_1_b']}`}>
              <span className={`${styles['padding-l-5']}`}>杭州巨极下载科技有限公司</span>
              <span className={`${styles['padding-l-5']}`}>投诉建议：+86 -198 1844 4998 (工作日：09:00-22:00)</span>
              <span className={`${styles['padding-l-5']} ${styles['gongan-icon']}`}>浙公网安备 33011002017281号</span>
              <span className={`${styles['padding-l-5']}`}>浙ICP备2026044439号</span>
            </div>
          </div>
          {/* <div className={`${styles["group_21"]} flex-col`}>
          <div className={`${styles["box_15"]} flex-col`}>
            <div className={`${styles["section_17"]} flex-col`} />
          </div>
          <div className={`${styles["box_16"]} flex-col`}>
            <div className={`${styles["group_22"]} flex-col`} />
          </div>
        </div> */}
          {/* <div className={`${styles["group_23"]} flex-col`}>
          <div className={`${styles["block_10"]} flex-row`}>
            <span className={`${styles["text_32"]}`}>领取现金红包</span>
            <img
              className={`${styles["image_12"]}`}
              src={require("./assets/img/SketchPngc4f3ad483c74e9db2f03a7763c814e46ee71ef57dbcb24f369216443ddf97f60.png")}
            />
          </div>
        </div> */}
        </div>
      )}
      {visiable && (
        <div className={`${styles.outerLayer} outerLayer-esports`}>
          <div>
            {currentStep === 1 && <Step1 handleCloseDownload={handleCloseDownload} setCurrentStep={setCurrentStep} productDetailData={productDetailData} setUserData={setUserData} userData={userData} isEsports={true} />}
            {currentStep === 2 && <Step2 handleCloseDownload={handleCloseDownload} setCurrentStep={setCurrentStep} productDetailData={productDetailData} userData={userData} setPayResult={setPayResult} isEsports={true} />}
            {currentStep === 3 && <Step3 handleCloseDownload={handleCloseDownload} productDetailData={productDetailData} payResult={payResult} isEsports={true} />}
          </div>
        </div>
      )}
    </div>
  );
};
export default DF;
